import React from "react";

export default function ErrorPage() {
  return (
    <div className="mt-40 w-11/12 flex items-center justify-center mx-auto">
      <div className=" text-white text-3xl font-semibold  mx-auto flex items-center justify-center text-center">
        Error 404
      </div>
    </div>
  );
}
